import React from 'react';
import styled from "styled-components";
import Icn from "./Icn";
import {colors} from "../maps/colors";

const WrapperStyled = styled.div`
  width: 100%;
  text-align: right;
  padding: 0 6px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  height: 30px;
  justify-items: right;
  background: ${colors.GREEN};
  margin-bottom: 2px;
  color: #fff;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;

  span {
    margin-right: 10px;
  }

  svg {
    cursor: pointer;
  }

  .rotate {

    svg {
      transform: rotate(90deg);
    }
  }
`;

const LeftSideStyled = styled.div`
  display: grid;
  justify-self: left;

  h3 {
    margin: 0;
    font-size: 16px;
    display: grid;
    grid-template-columns: auto 1fr;
    align-items: center;
  }

  svg {
    width: 14px;
    position: relative;
    color: ${colors.WHITE};
  }
`;

const RightSideStyled = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  
  span {
    margin-right: 10px;
    height: 25px;
  }
`;


const ActionBarForWidget = (props) => {
    const {
        title,
        titleIcon,
        children,
        showPlus = true,
        showMinus = true,
        showFullscreen = true,
        showMinimalscreen = true,
        onPlusClick,
        onMinusClick,
        onFullScreenClick,
        onMinScreenClick
    } = props;

    return (
        <WrapperStyled>
            <LeftSideStyled>
                <h3>
                    {titleIcon && (
                        <Icn style={{color: colors.WHITE}}>{titleIcon}</Icn>
                    )}
                    {title && (
                        <span style={{fontWeight: 500}}>{title}</span>
                    )}
                </h3>
            </LeftSideStyled>

            <RightSideStyled>
                {children}
                {showFullscreen && (
                    <span
                        onClick={onFullScreenClick}>
                    <Icn style={{width: 16, cursor: 'pointer', color: colors.WHITE}}>
                        checkBoxOutlineBlankIcon
                    </Icn>
                  </span>
                )}
                {showMinimalscreen && (
                    <span
                        onClick={onMinScreenClick}>
                    <Icn style={{width: 16, cursor: 'pointer', color: colors.WHITE}}>
                        minimizeIcon
                    </Icn>
                  </span>
                )}
                {showPlus && (
                    <span
                        onClick={onPlusClick}
                    >
                    <Icn style={{color: colors.WHITE}}>
                        add
                    </Icn>
                  </span>
                )}
                {showMinus && (
                    <span
                        onClick={onMinusClick}
                    >
                    <Icn style={{color: colors.WHITE}}>
                        removeIcon
                    </Icn>
                  </span>
                )}
            </RightSideStyled>
        </WrapperStyled>
    );
};

export default ActionBarForWidget;